import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature99',
    },
    page: {
      className: 'home-page feature99-page',
    },
    bg: {
      className: 'bg',
      children:
        'https://imm.86links.com/assets/landing/feature/template/feature99-bg.png',
    },
    content: {
      className: 'feature99-content',
      left: {
        className: 'feature99-content-left',
        title: {
          className: 'feature99-content-left-title',
          children: [
            {
              name: '标题',
              className: 'feature99-content-left-title-item',
              children: '新经济',
            },
          ],
        },
        box: {
          className: 'feature99-content-left-box',
          children: [
            {
              name: '项目0',
              className: 'feature99-content-left-box-item',
              children: [
                {
                  name: '图标0',
                  className: 'icon',
                  children:
                    'https://imm.86links.com/assets/landing/feature/template/feature99-icon1.png',
                },
                {
                  name: '内容0',
                  className: 'text',
                  children:
                    '聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。',
                },
              ],
            },
            {
              name: '项目1',
              className: 'feature99-content-left-box-item',
              children: [
                {
                  name: '图标1',
                  className: 'icon',
                  children:
                    'https://imm.86links.com/assets/landing/feature/template/feature99-icon2.png',
                },
                {
                  name: '内容1',
                  className: 'text',
                  children:
                    '汽车+新经济创新产业园""哈工大智能经济产业园"汽车智创活力港等新经济发展载体10余家，科创新经济走廊"逐步形成。',
                },
              ],
            },
          ],
        },
      },
      right: {
        className: 'feature99-content-right',
        children: [
          {
            name: '背景',
            className: 'fixed-right',
            children: '',
          },
          {
            name: '图片',
            className: 'feature99-content-right-image',
            children:
              'https://imm.86links.com/assets/landing/feature/template/feature99-right.png',
          },
        ],
      },
    },
  },
};
